/**
 * Run a callback once the shared Swiper bundle (lib/swiper.min.js) has executed.
 *
 * Every bundle is included with `async`, so the browser runs them in whatever order they finish
 * downloading - a slider component can be initialised by Alpine before Swiper exists. Checking
 * `typeof Swiper` and bailing out (what the timelines used to do) leaves the slider dead whenever
 * the network orders it that way. lib/swiper.js sets window.Swiper and then dispatches
 * "swiper:ready"; this waits for whichever of the two is already true.
 *
 * The callback receives Swiper and the module map, so a slider can pass exactly the modules it uses:
 *
 *   whenSwiper((Swiper, modules) => new Swiper(el, { modules: [modules.Navigation] }))
 *
 * @param {(Swiper: typeof import('swiper').default, modules: Record<string, unknown>) => void} callback
 */
export function whenSwiper(callback) {
    if (typeof window.Swiper === 'function') {
        callback(window.Swiper, window.SwiperModules || {})
        return
    }
    let ready = false
    document.addEventListener('swiper:ready', () => {
        ready = true
        callback(window.Swiper, window.SwiperModules || {})
    }, { once: true })
    // Waiting used to be silent: a template that included HeroSlider.js but not lib/swiper.min.js
    // left the slider dead without a single console line. Say so once per page.
    if (!warningScheduled) {
        warningScheduled = true
        window.setTimeout(() => {
            if (!ready && typeof window.Swiper !== 'function') {
                console.warn('[whenSwiper] Swiper did not load within ' + (WARN_AFTER_MS / 1000) + ' s - is lib/swiper.min.js included? Render partial "Assets/Swiper" in the slider template.')
            }
        }, WARN_AFTER_MS)
    }
}

const WARN_AFTER_MS = 10000
let warningScheduled = false
